import styled from 'styled-components';
import { Stack } from 'components/Stack';

export const SectionContainer = styled.div<{ block: boolean }>`
  width: ${({ block }) => block && '100%'};
  border: 1px solid rgba(0, 0, 0, 0.2);
`;

export const SectionHeader = styled(Stack).attrs({
  justify: 'center',
  align: 'center',
})`
  height: 56px;
  background-color: ${({ theme }) => `${theme.configs.mainBox.bgColor}`};
  color: ${({ theme }) => `${theme.configs.mainBox.fontColor}`};
  font-weight: 700;
  text-align: center;
`;
